import styled from '@emotion/styled';

export const SadaAppointmentTimeTag = styled.div``;
